 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML02_COPYRIGH from '@/components/xhtml/02_Copyrigh'
 import XHTML01_TITLE_PA from '@/components/xhtml/01_Title_Pa'
 import XHTML03_DEDICATI from '@/components/xhtml/03_Dedicati'
 import XHTML04_CONTENTS from '@/components/xhtml/04_Contents'
 import XHTML05_FOREWORD from '@/components/xhtml/05_Foreword'
 import XHTML06_PREFACE from '@/components/xhtml/06_Preface'
 import XHTML07_1__A_NEW from '@/components/xhtml/07_1__A_New'
 import XHTML08_2__GLOBA from '@/components/xhtml/08_2__Globa'
 import XHTML09_3__ENGLI from '@/components/xhtml/09_3__Engli'
 import XHTML10_4__IMPAC from '@/components/xhtml/10_4__Impac'
 import XHTML11_5__PAST from '@/components/xhtml/11_5__Past'
 import XHTML12_6__DOES from '@/components/xhtml/12_6__Does'
 import XHTML13_NOTES from '@/components/xhtml/13_Notes'
 import XHTML14_INDEX from '@/components/xhtml/14_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/04_Contents",
 			"name" : "xhtml/04_Contents",
 			"component" : XHTML04_CONTENTS
 		},
 		{
 			"path" : "/xhtml/05_Foreword",
 			"name" : "xhtml/05_Foreword",
 			"component" : XHTML05_FOREWORD
 		},
 		{
 			"path" : "/xhtml/06_Preface",
 			"name" : "xhtml/06_Preface",
 			"component" : XHTML06_PREFACE
 		},
 		{
 			"path" : "/xhtml/07_1__A_New",
 			"name" : "xhtml/07_1__A_New",
 			"component" : XHTML07_1__A_NEW
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js